/**
 * Guard de **sesión**: exige usuario autenticado (cualquier rol). Si el estado sigue en
 * `checking`, fuerza reautenticación antes de decidir redirección.
 *
 * @see AuthService.redirectIfUserIsNotAuth
 */

import { CanActivateFn } from '@angular/router';
import { AuthService } from '../../features/auth/services/auth.service';
import { inject } from '@angular/core';
import { AuthStatus } from '../models/auth.model';

export const isAuthGuard: CanActivateFn = () => {
  const authService = inject(AuthService);

  if (authService.authStatus() === AuthStatus.checking) {
    const updatedAuthStatus = authService.reauthenticate();

    return authService.redirectIfUserIsNotAuth(updatedAuthStatus);
  }

  return authService.redirectIfUserIsNotAuth(authService.authStatus());
};
